import { Fragment, useState } from "react";
import {
  Grid,
  InputAdornment,
  IconButton,
  Tooltip,
  MenuItem,
  Typography,
} from "@mui/material";
import { useDispatch, useSelector } from "react-redux";
import { InfoOutlined } from "@mui/icons-material";

import ActionButtons from "./ActionButtons";
import { useAxios, useComponent } from "../../../hooks";
import { PrimaryLoadingButton } from "../../css components/Button";
import {
  Autocomplete,
  TextField,
  ComponentHeader,
  Label,
} from "../../../components";

export default function FormOne({
  setEditState,
  formikProps,
  brands,
  editState,
}) {
  const axios = useAxios();
  const dispatch = useDispatch();
  const { alert } = useComponent();
  const { siteColors } = useSelector((state) => state.renderUIDetails);

  const [loading, setLoading] = useState(false);

  function handleConnection() {
    setLoading(true);
    axios({
      url: "/user/testConnectionDetails",
      method: "POST",
      data: {
        connection_url: formikProps.values.connectionUrl,
        port: formikProps.values.port,
        token: formikProps.values.token,
      },
      disableRedirect: true,
    }).then((res) => {
      if (res.status) {
        formikProps.setValues((prev) => ({
          ...prev,
          connection:
            res.data[0].connection_establishment === "success" ? true : false,
          fieldNames: res.data[1].column_names,
        }));
        dispatch(
          alert.success(res.data[0]?.connection_establishment || "Success")
        );
      } else {
        dispatch(alert.error(res.message));
      }

      setLoading(false);
    });
  }

  return (
    <Fragment>
      <Grid item xs={12}>
        <ComponentHeader
          title={"Brand Details"}
          buttons={[
            <ActionButtons
              formikProps={formikProps}
              editState={editState}
              setEditState={setEditState}
            />,
            <Grid item>
              <PrimaryLoadingButton
                loading={loading}
                variant="contained"
                onClick={handleConnection}
                disabled={
                  !formikProps.values.connectionUrl && !formikProps.values.port
                }
              >
                Test Connection
              </PrimaryLoadingButton>
            </Grid>,
          ]}
        />
      </Grid>

      <Grid item xs={4}>
        {!!formikProps.values.connectionID ? (
          <Fragment>
            <Label title="Brand Name" />

            <TextField
              name="brandName"
              formikProps={formikProps}
              disabled={!!formikProps.values.connectionID}
            />
          </Fragment>
        ) : (
          <Fragment>
            <Label
              title="Brand Name"
              formikProps={formikProps}
              required={true}
              name="brandID"
            />

            <Autocomplete
              name="brandID"
              forcePopupIcon={!editState ? false : true}
              placeholder="Select Brand Name"
              defaults={{
                primaryKey: "brand_id",
                displayLabel: "brand_name",
              }}
              options={brands}
              disabled={!!formikProps.values.connectionID}
              onChange={(_, value, type) => handleChangeBrand(value, type)}
              formikProps={formikProps}
            />
          </Fragment>
        )}

        {/* <FormControlLabel
          control={
            <Checkbox
              disabled={!editState}
              onChange={(e) => {
                formikProps.setValues((prev) => ({
                  ...prev,
                  csvUpload: e.target.checked,
                }));
              }}
              checked={formikProps.values.csvUpload}
              sx={{
                color: siteColors?.primary,
                "&.Mui-checked": {
                  color: siteColors?.primary,
                },
              }}
            />
          }
          label="Onboarding with CSV"
        /> */}
      </Grid>

      {!formikProps.values.csvUpload && (
        <Fragment>
          <Grid item xs={4}>
            <Label
              title="IP/Domain"
              formikProps={formikProps}
              required={true}
              name="connectionUrl"
            />

            <TextField
              required
              name="connectionUrl"
              placeholder="IP/Domain"
              disabled={!editState}
              formikProps={formikProps}
              InputProps={{
                endAdornment: (
                  <InputAdornment position={"end"}>
                    <Tooltip title="Provide either domain or ip:port">
                      <IconButton style={{ padding: 0 }}>
                        <InfoOutlined />
                      </IconButton>
                    </Tooltip>
                  </InputAdornment>
                ),
              }}
            />
          </Grid>

          <Grid item xs={4}>
            <Label
              title="Status"
              formikProps={formikProps}
              required={true}
              name="status"
            />

            <TextField
              select
              required
              name="status"
              placeholder="Status"
              disabled={!editState}
              formikProps={formikProps}
            >
              <MenuItem value="ACTIVE">Active</MenuItem>
              <MenuItem value="INACTIVE">In Active</MenuItem>
            </TextField>
          </Grid>

          <Grid item xs={6}>
            <Label
              title="Token"
              formikProps={formikProps}
              required={true}
              name="token"
            />

            <TextField
              multiline
              name="token"
              placeholder="Token"
              disabled={!editState}
              formikProps={formikProps}
            />
          </Grid>
        </Fragment>
      )}

      <Grid item xs={12}>
        <Typography variant="h6">Prime Identifier</Typography>
      </Grid>

      <Grid item xs={4}>
        <Label
          title="Mobile"
          formikProps={formikProps}
          required={true}
          name="mobile"
        />

        <TextField
          required
          name="mobile"
          placeholder="Enter Mobile Identifier"
          disabled={!editState}
          formikProps={formikProps}
          InputLabelProps={{ shrink: true }}
        />
      </Grid>

      <Grid item xs={12}>
        <Typography variant="h6">Other Identifier</Typography>
      </Grid>

      <Grid item xs={4}>
        <Label
          title="Email"
          formikProps={formikProps}
          required={true}
          name="email"
        />

        <TextField
          name="email"
          placeholder="Enter Email Identifier"
          disabled={!editState}
          formikProps={formikProps}
          InputLabelProps={{ shrink: true }}
        />
      </Grid>

      <Grid item xs={4}>
        <Label
          title="GAID"
          formikProps={formikProps}
          required={true}
          name="gaid"
        />

        <TextField
          name="gaid"
          placeholder="Enter GAID Identifier"
          disabled={!editState}
          formikProps={formikProps}
          InputLabelProps={{ shrink: true }}
        />
      </Grid>
    </Fragment>
  );

  function handleChangeBrand(value, type) {
    if (type === "selectOption") {
      formikProps.setValues((prevVal) => ({
        ...prevVal,
        brandID: value.brand_id,
      }));
    } else {
      value = {
        brand_id: "",
        brand_name: "",
      };

      formikProps.setValues((prevVal) => ({
        ...prevVal,
        brandID: value.brandID,
      }));
    }
  }
}
